import jquery from 'jquery';
window.$ = window.jQuery = jquery;

import Swiper from 'swiper';
import { Autoplay, Pagination, Navigation, Thumbs, Mousewheel } from 'swiper/modules';
Swiper.use([Autoplay, Pagination, Navigation, Thumbs, Mousewheel]);
window.Swiper = Swiper;

import WOW from 'wow.js';
window.WOW = WOW;

import 'magnific-popup';
import 'slick-carousel';
import select2 from 'select2';
import 'nouislider';
import * as bootstrap from 'bootstrap';
import toastr from 'toastr';
import Pusher from 'pusher-js';
import Odometer from 'odometer';

select2($);

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.odometer')) {
        const odo = new Odometer({
            el: document.querySelector('.odometer'),
            value: 0,
            duration: 4000
        });
    }
});

(function() {
    let openModalsCount = 0;

    document.addEventListener('show.bs.modal', function () {
        openModalsCount++;
    });

    document.addEventListener('hidden.bs.modal', function () {
        openModalsCount = Math.max(0, openModalsCount - 1);

        if (openModalsCount > 0) {
            document.body.classList.add('modal-open');
            document.body.style.overflow = 'auto';
        }
    });
})();

document.addEventListener('DOMContentLoaded', () => {
    if (!window.appConfig) return;

    const productId = window.appConfig.productId;
    const pusherKey = window.appConfig.pusherKey;
    const pusherCluster = window.appConfig.pusherCluster;

    const counter = document.getElementById('viewer-counter');
    let currentViewers = 0;

    const pusher = new Pusher(pusherKey, {
        cluster: pusherCluster,
        forceTLS: true,
    });

    function updateViewerCount(count) {
        if (counter) {
            counter.textContent = count;
            currentViewers = count;
        }
    }

    const channel = pusher.subscribe(`product.viewers.${productId}`);
    channel.bind('App\\Events\\ProductViewingEvent', (data) => {
        if (counter) counter.textContent = data.viewersCount;
    });

    // Track view
    fetch(`/products/track-view/${productId}`, {
        method: 'POST',
        headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
            'Content-Type': 'application/json'
        },
        keepalive: true
    })
    .then((res) => res.json())
    .then((data) => updateViewerCount(data.count));

    // Untrack view
    window.addEventListener('beforeunload', () => {
        fetch(`/products/untrack-view/${productId}`, {
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
            },
            keepalive: true
        });
    });
});

window.bootstrap = bootstrap;
window.toastr = toastr;

if (typeof toastr !== 'undefined') {
    toastr.options = {
        closeButton: true,
        positionClass: 'toast-bottom-left',
        showDuration: 1000,
        progressBar: true,
        newestOnTop: true
    };
}

document.addEventListener('DOMContentLoaded', function() {
    if (typeof $.fn.modal !== 'undefined' && typeof toastr !== 'undefined') {
        document.dispatchEvent(new CustomEvent('libraries-loaded'));
    } else {
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('libraries-loaded'));
        }, 100);
    }
});


window.TouchSpin = function() {
    if (typeof $ !== 'undefined' && typeof $.fn.TouchSpin !== 'undefined') {
        $('input.quantity-spinner').TouchSpin({
            verticalbuttons: true,
            min: 1,
            max: 100,
            step: 1
        }).on('keypress', function (e) {
            if (e.which < 48 || e.which > 57) {
                e.preventDefault(); 
            }
        })
        .off('change keyup input')
        .on('change keyup input', function () {
            let quantity = parseInt($(this).val());

            if (isNaN(quantity) || quantity < 1) {
                quantity = 1;
                $(this).val(quantity);
            }
        });
    }
};

window.magnificPopup = function() {
    if (typeof $ !== 'undefined' && typeof $.fn.magnificPopup !== 'undefined') {
        if ($(".video-popup").length) {
            $(".video-popup").magnificPopup({
                type: "iframe",
                mainClass: "mfp-fade",
                removalDelay: 160,
                preloader: true,

                fixedContentPos: true,
            });
        }
    }
};

const loadLegacyScripts = async () => {
    try {
        await import('../assets/web/js/jquery.appear.js');
        await import('../assets/web/js/jquery.circleType.js');
        await import('../assets/web/js/jquery.lettering.min.js');
        await import('../assets/web/js/jquery.nice-select.min.js');
        await import('../assets/web/js/jquery-sidebar-content.js');
        await import('../assets/web/vendor/touch-spin/jquery.bootstrap-touchspin.js');
        await import('../assets/web/js/main.js');

        // console.log('All legacy scripts loaded successfully');
    } catch (error) {
        // console.error('Error loading legacy scripts:', error);
    }
};

window.wowAnimation = function() {
    if (typeof WOW !== 'undefined') {
        var wow = new WOW({
            boxClass: "wow",
            animateClass: "animated",
            offset: 0,
            mobile: false,
            live: true,
        });
        wow.init();
    }
};

document.addEventListener('DOMContentLoaded', function() {
    loadLegacyScripts().then(() => {
        initAll();
    });
});

/*function preloader() {
    $("#preloader").delay(0).fadeOut();
}

$(window).on("load", function () {
    preloader();
    if ($(".curved-circle").length) {
        $(".curved-circle").circleType({
            position: "absolute",
            dir: 1,
            radius: 76,
            forceHeight: true,
            forceWidth: true,
        });
    }

    if ($(".curved-circle-2").length) {
        $(".curved-circle-2").circleType({
            position: "absolute",
            dir: 1,
            radius: 71,
            forceHeight: true,
            forceWidth: true,
        });
    }

    if ($(".curved-circle-3").length) {
        $(".curved-circle-3").circleType({
            position: "absolute",
            dir: 1,
            radius: 76,
            forceHeight: true,
            forceWidth: true,
        });
    }
});*/

function initAll() {

    const wrappers = document.querySelectorAll(".password-wrapper");
    wrappers.forEach(wrapper => {
        const input = wrapper.querySelector(".password-input");
        const toggleBtn = wrapper.querySelector(".toggle-btn");

        toggleBtn.addEventListener("click", () => {
            if (input.type === "password") {
                input.type = "text";
                toggleBtn.classList.remove("hiding");
                toggleBtn.classList.add("showing");
            } else {
                input.type = "password";
                toggleBtn.classList.remove("showing");
                toggleBtn.classList.add("hiding");
            }
        });
    });
    
    $(document).on('click', 'a', function(e){
        if(typeof(this.href) == 'undefined' || this.href == 'javascript:void(0)') {
            $(this).attr('href', 'javascript:void(0)');
            e.preventDefault();
        }
    });
    
    /*$('#buttonsearch').click(function () {
        $('#formsearch').slideToggle("fast", function () {
            $('#content').toggleClass("moremargin");
        });
        $('#searchbox').focus()
        $('.openclosesearch').toggle();
    });*/

    $('.buttonsearch').on('click', function () {
        const formDiv = $(this).next('.searchbardiv');
        formDiv.slideToggle("fast");
        formDiv.find('input[type="search"]').focus();
        $(this).find('.openclosesearch').toggle();
    });

    $(document).ready(function() {
        const progressCircle = document.querySelector(".autoplay-progress svg");
        const progressContent = document.querySelector(".autoplay-progress span");
        const swiperEl = document.querySelector(".thm-swiper__slider");

        if (!swiperEl || !progressCircle || !progressContent) return;

        const autoplayDelay = swiperEl.dataset.swiperAutoplayDelay || 9000;
        return new Swiper(".thm-swiper__slider", {
            slidesPerView: 1,
            loop: true,
            speed: 1200,
            watchSlidesProgress: true,
            modules: [Autoplay, Pagination, Navigation],
            autoplay: {
                delay: parseInt(autoplayDelay),
                disableOnInteraction: false
            },
            pagination: {
                el: "#main-slider-two__pagination",
                type: "bullets",
                clickable: true
            },
            navigation: {
                nextEl: "#main-slider__swiper-button-next",
                prevEl: "#main-slider__swiper-button-prev"
            },
            on: {
                autoplayTimeLeft(s, time, progress) {
                    if (progressCircle && progressContent) {
                        progressCircle.style.setProperty("--progress", 1 - progress);
                        progressContent.textContent = `${Math.ceil(time / 1000)}s`;
                    }
                }
            }
        });
    });

    if ($("#product-one__thumb").length) {
        let thumbCount = document.querySelectorAll('#product-one__thumb .swiper-slide').length;
        let productThumb;
        if(thumbCount < 5) {
            productThumb = new Swiper("#product-one__thumb", {
                slidesPerView: document.querySelectorAll('#product-one__thumb .swiper-slide').length,
                spaceBetween: 10,
                speed: 1400,
                loop: false,
                centeredSlides: false,
            });
        } else {
            productThumb = new Swiper("#product-one__thumb", {
                slidesPerView: 4,
                spaceBetween: 10,
                speed: 1400,
                loop: false,
                centeredSlides: false,
            });
        }

        if (thumbCount <= 2) {
            document.querySelectorAll('#product-one__thumb .swiper-slide').forEach(img => {
                img.style.maxWidth = '165px';
            });
        }

        let productCarousel = new Swiper("#product-one__carousel", {
            observer: true,
            observeParents: true,
            speed: 1400,
            mousewheel: true,
            loop: true,
            slidesPerView: 1,
            autoplay: {
                delay: 5000,
            },
            thumbs: {
                swiper: productThumb,
            },
            pagination: {
                el: "#product-one__pagination",
                type: "bullets",
                clickable: true,
            },

            navigation: {
                nextEl: "#product-three__swiper-button-next",
                prevEl: "#product-three__swiper-button-prev",
            },
        });
    }

    if ($(".thm-swiper__product").length) {
        var swiper = new Swiper(".thm-swiper__product", {
            slidesPerView: 3,
            spaceBetween: 30,
            loop: true,
            speed: 1200,
            autoplay: {
                delay: 9000,
            },
            navigation: {
                nextEl: "#main-slider__swiper-button-next",
                prevEl: "#main-slider__swiper-button-prev"
            },
            breakpoints: {
                "0": {
                    "spaceBetween": 30,
                    "slidesPerView": 1
                },
                "375": {
                    "spaceBetween": 30,
                    "slidesPerView": 1
                },
                "575": {
                    "spaceBetween": 30,
                    "slidesPerView": 2
                },
                "768": {
                    "spaceBetween": 30,
                    "slidesPerView": 2
                },
                "992": {
                    "spaceBetween": 30,
                    "slidesPerView": 3
                },
                "1200": {
                    "spaceBetween": 30,
                    "slidesPerView": 4
                }
            }
        });
    }

    if ($(".thm-swiper__slider").length) {
    $(".thm-swiper__slider").each(function () {
        let $this = $(this);
        let options = $this.data('swiper-options');
        
        // التحقق من أن الخيارات موجودة كـ Object وليس String
        if (typeof options === 'string') {
            options = JSON.parse(options);
        }
        
        new Swiper($this[0], options);
    });
}

}
